
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.516 4.438l3.507 3.546-.78.782-3.5-3.57-3.61 3.538L.406 8l3.57-3.563L.423.93l.781-.782 3.54 3.532L8.28.148l.735.727-3.5 3.563z","fill":"currentColor"}})])
          )
        }
      }
    